'use client';

import React, { useState } from 'react';
import { Share2, Check } from 'lucide-react';

interface ShareButtonProps {
  title?: string;
  text?: string;
  url?: string;
  className?: string;
  iconOnly?: boolean;
}

export function ShareButton({
  title = 'CRM Documents',
  text = 'Schau dir diesen Beleg an:',
  url,
  className = '',
  iconOnly = false,
}: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const shareUrl = url || window.location.href;
    const shareData = { title, text, url: shareUrl };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch {
        // User may have cancelled the share dialog
      }
    } else {
      // Fallback: copy to clipboard
      try {
        await navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error('Kopieren fehlgeschlagen', err);
      }
    }
  };

  return (
    <button
      onClick={handleShare}
      className={`flex items-center justify-center gap-2 transition-colors cursor-pointer ${className}`}
      title="Teilen"
      type="button"
    >
      {copied ? <Check size={18} /> : <Share2 size={18} />}
      {!iconOnly && (
        <span className="font-medium">
          {copied ? 'Link kopiert!' : 'Teilen'}
        </span>
      )}
    </button>
  );
}
